class ResizeImage extends HTMLElement{
    constructor(){
        super();
        this.imgs = this.querySelectorAll('img');
    }

    connectedCallback(){
        this.resizeImages();
    }

    resizeImages(){
        // console.log(this, this.querySelector('img').naturalWidth, this.querySelector('img').naturalHeight);
        this.imgs.forEach((img) => {
            if(img.naturalWidth != 0 && img.naturalWidth == img.naturalHeight){
                img.style.objectFit = 'cover';
            };
        })
    }
}

customElements.define('resize-image', ResizeImage);